
import Vue from 'vue';
import ArrowDown from '../../../Icons/ArrowDownCircular.vue';
/**
 - This only includes the dynamic text that will change when expanded / not expanded
**/
export default Vue.extend<any, any, any, any>({
  name: 'ExpanderText',
  data() {
    return {
      expand: false
    };
  },
  components: {
    ArrowDown
  },
  props: {
    /**
     * Set id in the tooltips
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set label for see more button
     */
    seeMoreLabel: {
      type: String,
      default: 'See more'
    },
    /**
     * Set label for see less button
     */
    seeLessLabel: {
      type: String,
      default: 'View less'
    },
    /**
     * Set color for the circle
     */
    circleFill: {
      type: String,
      default: '#4c75a7'
    },
    /**
     * Set color for the arrow
     */
    arrowFill: {
      type: String,
      default: 'white'
    },
    /**
     * Set customisable arrow icon
     */
    arrowIcon: {
      type: Object,
      default: () => ArrowDown
    }
  },
  computed: {
    computedArrow() {
      if (this.expand) {
        return `transform: rotate(180deg) translateY(1px)`;
      }
      return ``;
    },
    computedButtonLabel() {
      if (this.expand) {
        return this.seeLessLabel;
      }
      return this.seeMoreLabel;
    }
  },
  methods: {
    handleClick(e: any) {
      this.expand = !this.expand;
      /**
       * Method to click the expander text
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    }
  }
});
